import { Box, IconButton } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { IconCaret } from "src/components/icons";

interface IExpandButtonProps {
    onClick: () => void;
}

export const ExpandButton = ({ onClick }: IExpandButtonProps) => {
    const { t } = useTranslation("common");
    return (
        <Box isolation="isolate">
            <IconButton
                aria-label={t("show-more-categories")}
                background="gray.800"
                color="white"
                onClick={onClick}
                variant="filled"
                size="xs"
                rounded="16px"
                pos="absolute"
                bottom="0"
                right="0"
                icon={<IconCaret boxSize={2} />}
                sx={{
                    _before: {
                        content: '""',
                        position: "absolute",
                        top: "-1px",
                        left: "-100%",
                        right: "50%",
                        bottom: "-1px",
                        zIndex: "-1",
                        background: "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 60%)",
                        pointerEvents: "none",
                    },
                }}
            />
        </Box>
    );
};
